// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__tSiOp","modalContent":"styles_modalContent__EqwFv","closeButton":"styles_closeButton__Jb+iP"};